import { render, staticRenderFns } from "./Snakes.container.vue?vue&type=template&id=434991c5&scoped=true&"
import script from "./Snakes.container.vue?vue&type=script&lang=js&"
export * from "./Snakes.container.vue?vue&type=script&lang=js&"
import style0 from "./Snakes.container.vue?vue&type=style&index=0&id=434991c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434991c5",
  null
  
)

export default component.exports